import { createStore } from 'satcheljs';
import { IFilterViewState } from './schema/IFilterViewState';

export const getFilterStore = createStore<IFilterViewState>('FilterState', {
  active: {},
  errors: {}
});
